import React, { useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import { useToast } from "./ToastProvider";


function Contact() {

  const [name, setName] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const { showToast } = useToast();

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(userEmail === '');
    setPhoneError(phone === '');
    setMessageError(message === '');

    /* Uncomment below if you want to enable the emailJS */

    if (name !== '' && userEmail !== '' && message !== '') {
      var templateParams = {
        name: name,
        userEmail: userEmail,
        email: 'adiphilipswork@gmail.com',
        phone: phone,
        message: message

      };

      emailjs.send('service_pgmu8ji', 'template_715e0na', templateParams, 'ucPl6Ios3mcwRy1Vg').then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          showToast("Request received — we’ll be in touch soon.", "success");
        },
        (error) => {
          console.log('FAILED...', error);
        },
      );
      setName('');
      setUserEmail('');
      setPhone('');
      setMessage('');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Us</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
            <div className='form-flex'>
              <TextField
                required
                type='text'
                id="contact-name"
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
              />
              <TextField
                required
                type="email"
                id="contact-email"
                label="Email"
                placeholder="How can I reach you?"
                value={userEmail}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? "Please enter your email" : ""}
              />
              <TextField
                required
                type='tel'
                id="contact-phone"
                label="Phone"
                placeholder="Your phone number"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                error={phoneError}
                helperText={phoneError ? "Please enter your phone number" : ""}
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;